import { render, staticRenderFns } from "./imgDialog.vue?vue&type=template&id=28671480&scoped=true&"
import script from "./imgDialog.vue?vue&type=script&lang=js&"
export * from "./imgDialog.vue?vue&type=script&lang=js&"
import style0 from "./imgDialog.vue?vue&type=style&index=0&id=28671480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!C:\\Users\\86177\\AppData\\Roaming\\npm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28671480",
  null
  
)

export default component.exports